<template>
  <div class="logo-decision-tree-content" id="identidade-visual-logo-arvore-de-decisao" data-search-anchor>
    <div class="title-logo-decision-tree-wrapper">
      <h1 class="logo-decision-tree-title-span">{{ logoDecisionTreeTitleSpan }}</h1>
      <h1 class="logo-decision-tree-title">{{ logoDecisionTreeTitle }}</h1>
    </div>
    <div class="description-logo-decision-tree-wrapper">
      <p class="logo-decision-tree-description" style="margin-top: 0;">
        {{ logoDecisionTreeDescriptionParagraph1 }}
      </p>
      <p class="logo-decision-tree-description">
        {{ logoDecisionTreeDescriptionParagraph2 }}
      </p>
      <p class="logo-decision-tree-description">
        {{ logoDecisionTreeDescriptionParagraph3 }}
      </p>
    </div>
    <div
      class="logo-decision-tree-card-item"
      :style="{ backgroundImage: `url(${logoDecisionTreeImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import VisualIdentityPageMixin from '@/mixins/visual-identity-page-mixin'
import { VisualIdentityPageStore } from '@/store/visual-identity-page/visual-identity-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class LogoDecisionTreeSection extends Mixins(VisualIdentityPageMixin) {
  visualIdentityPageStore: PageStoreContract = getModule(VisualIdentityPageStore, this.$store)

  get logoDecisionTreeTitleSpan(): string {
    return this.getElementTitle(14, 0)
  }

  get logoDecisionTreeTitle(): string {
    return this.getElementText(14, 0)
  }

  get logoDecisionTreeDescriptionParagraph1(): string {
    return this.getElementText(14, 1)
  }

  get logoDecisionTreeDescriptionParagraph2(): string {
    return this.getElementText(14, 2)
  }

  get logoDecisionTreeDescriptionParagraph3(): string {
    return this.getElementText(14, 3)
  }

  get logoDecisionTreeImageSrc(): string {
    return this.getElementMedia(14, 4)
  }

  async getVisualIdentityPage(): Promise<void> {
    await this.visualIdentityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.visualIdentityPageStore.isLoading) {
      await this.getVisualIdentityPage()
    }
  }
}
</script>

<style lang="scss">
.logo-decision-tree-content {
  display: grid;  
  width: 100%;
  max-width: 1032px;
}

.title-logo-decision-tree-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 2rem;
}

.description-logo-decision-tree-wrapper {  
  position: relative;  

  width: 50rem;
}

.logo-decision-tree-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.logo-decision-tree-restricted-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.logo-decision-tree-description {
  font-size: 50px;
  font-weight: 400;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;
}

.logo-decision-tree-card-item {
  position: relative;  

  max-width: 1032px;
  width: 100%;
  height: 705px;  
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>
